import styled from 'styled-components'
import { theme } from '../../../styles/theme'
import LoginBg from '../../../assets/png/login-bg.png'
import FooterBgSvg from '../../../assets/svg/footer-bg.svg'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;

  position: relative;

  overflow: hidden;
  background-image: url(${LoginBg});
  background-repeat: no-repeat, no-repeat;
  background-size: cover;
  
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Wrapper = styled.main`
  margin-bottom: 100px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 88px;
`

export const Greetings = styled.div`
  width: 100%;
  max-width: 466px;

  & > h1 {
    font-family: ${theme.font.inter};
    font-size: ${theme.font.sizes.huge};
    color: ${theme.colors.white};
    font-weight: ${theme.font.bold};
    line-height: 77px;
  }

  & > p {
    width: 100%;
    max-width: 443px;
    margin-top: 10px;

    font-family: ${theme.font.inter};
    font-size: ${theme.font.sizes.xlarge};
    color: ${theme.colors.white};
    font-weight: ${theme.font.medium};
  }
`

export const FormWrapper = styled.form`
  width: 579px;
  padding: 50px 0px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  background: ${theme.colors.white};
  border-radius: ${theme.border.smallRadius};

  & > h2 {
    margin-bottom: 40px;

    font-family: ${theme.font.inter};
    font-size: ${theme.font.sizes.large};
    color: ${theme.colors.black};
    font-weight: ${theme.font.semiBold};
    line-height: 24px;
  }
`

export const FormContent = styled.div`
  width: 60%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  background: ${theme.colors.white};
  border-radius: ${theme.border.smallRadius};

  & > h2 {
    margin-bottom: 40px;

    font-family: ${theme.font.inter};
    font-size: ${theme.font.sizes.large};
    color: ${theme.colors.black};
    font-weight: ${theme.font.semiBold};
    line-height: 24px;
  }
`

export const ForgetPassword = styled.a`
  margin: 20px 0px 40px;

  align-self: flex-end;
  
  font-family: ${theme.font.inter};
  font-size: ${theme.font.sizes.small};
  line-height: 17px;
  text-decoration: underline;

  cursor: pointer;
`

export const Footer = styled.footer`
  height: 140px;

  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background-image: url(${FooterBgSvg});
  background-repeat: no-repeat, no-repeat;
  background-size: cover;

  & > img {
    margin-top: 30px;
  }
`

export const Support = styled.div`
  margin-top: 8px;

  display: flex;
  flex-direction: column;

  & > p {
    color: ${theme.colors.red};
    font-size: ${theme.font.sizes.xsmall};
    font-family:${theme.font.inter};
    font-weight: ${theme.font.bold};

    & > a {
      text-decoration: none;
      color: ${theme.colors.red};
      cursor: pointer;
    }
  }
`
